module.exports = __webpack_public_path__ + "static/media/03.e62cf7bc.png";